import React from "react";
import { useForm, useFieldArray } from "react-hook-form";

import {
  Grid,
  Typography,
  Paper,
  TextField,
  Button,
  IconButton,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";

export const ClientOffices = (props) => {
  const { classes, handleClose, data, handleOnSubmit, canEditClientOffices } =
    props;

  const formValue = {
    _id: data._id,
    branches: data.branches || [],
  };

  const { register, handleSubmit, control, errors, formState } = useForm({
    mode: "onChange",
    defaultValues: formValue,
  });

  const { fields, remove, append } = useFieldArray({
    control,
    name: "branches",
  });

  const onSubmit = (formData) => {
    console.log("Client Offices submitted:", formData);
    handleOnSubmit(formData);
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Paper className={classes.paper} variant="outlined">
              <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="flex-start"
              >
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  style={{
                    fontWeight: "600",
                    paddingBottom: "5px",
                  }}
                  color="primary"
                >
                  Branch Address
                </Typography>

                <Grid container spacing={1}>
                  {fields.map((item, index) => (
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                      key={item.id}
                      spacing={1}
                    >
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          label="Office Name"
                          size="small"
                          fullWidth
                          variant="outlined"
                          name={`branches[${index}].officeName`}
                          inputRef={register({
                            required: "Office name is required",
                            minLength: {
                              value: 2,
                              message: "Must have at least 2 letters",
                            },
                            maxLength: {
                              value: 50,
                              message: "Maximum characters limit is 50",
                            },
                          })}
                          defaultValue={item.officeName}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={5}>
                        <TextField
                          label="Office Address"
                          size="small"
                          fullWidth
                          variant="outlined"
                          name={`branches[${index}].officeAddress`}
                          inputRef={register({
                            required: "Office address is required",
                            minLength: {
                              value: 5,
                              message: "Must have at least 5 letters",
                            },
                            maxLength: {
                              value: 250,
                              message: "Maximum characters limit is 250",
                            },
                          })}
                          error={!!errors.branches?.[index]?.officeAddress}
                          helperText={
                            errors.branches?.[index]?.officeAddress &&
                            errors.branches[index].officeAddress.message
                          }
                          defaultValue={item.officeAddress}
                        />
                      </Grid>

                      <Grid item xs={10} sm={4} md={2}>
                        <TextField
                          label="Postcode"
                          size="small"
                          fullWidth
                          variant="outlined"
                          name={`branches[${index}].postcode`}
                          inputRef={register({
                            required: "Postcode is required",
                            pattern: {
                              value:
                                /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/,
                              message: "Invalid postcode",
                            },
                          })}
                          defaultValue={item.postcode}
                        />
                      </Grid>

                      <Grid item xs={2} sm={2} md={1}>
                        <IconButton
                          aria-label="delete"
                          color="secondary"
                          onClick={() => remove(index)}
                        >
                          <CancelIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>

                <Button
                  type="button"
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={() =>
                    append({
                      officeName: "",
                      officeAddress: "",
                      postcode: "",
                    })
                  }
                >
                  Add
                </Button>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="flex-end"
        >
          <div className={classes.actionBtn}>
            <Button
              type="button"
              size="small"
              color="primary"
              onClick={handleClose}
            >
              Cancel
            </Button>

            {canEditClientOffices && (
              <Button
                type="submit"
                size="small"
                variant="contained"
                color="primary"
                disabled={!formState.isDirty}
              >
                Update
              </Button>
            )}
          </div>
        </Grid>
      </form>
    </React.Fragment>
  );
};
